module.exports = __webpack_public_path__ + "img/DE00673.d318ebe4.png";